import { render, staticRenderFns } from "./svgSheypour.vue?vue&type=template&id=d353f1e2&scoped=true"
import script from "./svgSheypour.vue?vue&type=script&lang=js"
export * from "./svgSheypour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d353f1e2",
  null
  
)

export default component.exports